require('./commons/masks');
require('./commons/selects');
require('./commons/init-plugins');
require('./commons/setup-fields');



// WEBPACK FOOTER //
// ./resources/assets/js/commons.js